var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 855.233,
    height: 547.777,
    viewBox: "0 0 855.233 547.777",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-514 -257.762)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(700.352 257.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.154,
    height: 57.623,
    rx: 6.03,
    transform: "translate(332.091 79.373)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.733,
    height: 151.168,
    transform: "translate(326.862 109.853)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.237,372.333l8.8,63.928,4.145,30.048,1.525,11.036,12.776,24.906,23.46,45.707,45.25,5.435L416.8,441.128s41.68-79.655-21.69-72.422c-35.532,4.066-31.933-30.359-32.568-59.087-.16-14.464-10.9-26.29-8.144-40.489L291.04,299.911q2.209,10.293,3.323,18.914c3.089,23.518.528,38.181-4.829,47.066C275.273,389.556,241.237,372.333,241.237,372.333Z",
    transform: "translate(90.6 -137.107)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.321,
    cy: 73.321,
    rx: 73.321,
    ry: 73.321,
    transform: "translate(331.837 48.08)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.9,589.1c2.209,8.8-3.363,23.919-10.752,38.767,35.434,3.812,74.289,1.828,74.289,1.828l39.872,10.87L441.543,673.15c4.887-6.324,8.8-14.271,12.033-23.225l-11.124-12.981c-35-21.387-46.44-48.122-48.112-71.66a100.679,100.679,0,0,1,3.089-31.758,106.311,106.311,0,0,1,9.716-25.112l-104.19.489h-.88l-8.563,19.462-.391.88-6.373,14.477L265.028,504.8l-7.536-12.179-4.223-6.842s-62.461-14.506-63.37,22.639a99.22,99.22,0,0,0,.5,12.766c3.108,29.872,19.452,49.734,32.99,63.273A9.774,9.774,0,0,1,225.9,589.1Z",
    transform: "translate(117.494 -141.924)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.263,635.765c1.808,21.72,54.309-7.243,54.309-7.243s16.295-5.435,71.513-40.732a168.6,168.6,0,0,0,63.537-74.181,106.555,106.555,0,0,0,5.288-14.525L620.866,471l-11.094,16.959-36.881,56.352-54.309,36.167S462.455,614.045,464.263,635.765Z",
    transform: "translate(-356.017 -141.652)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.85,629.244H729.111l-79.7-27.414L450.172,533.289,323.122,489.58H159.48Z",
    transform: "translate(-60.23 -81.467)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.9,440.11l5.669,41.054,12.776,24.906a77.888,77.888,0,0,1,24.261-2.278c-9-1.241-14.819-57.5-14.819-57.5l-.518-.117Z",
    transform: "translate(-41.246 -140.957)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.48,486.314c18.1-2.717,38.924,23.538,38.924,23.538s24.437,23.538,40.732,7.243c15.786-15.786,43.459-13.685,45.179-13.587C503.315,502.257,497.5,446,497.5,446l-.518-.117L410.109,426.57s-5.181,7.937-11.026,18.044C388.536,462.825,375.829,488.064,387.48,486.314Z",
    transform: "translate(-129.874 -140.652)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,374.562l8.8,63.928,4.145,30.048C408.782,467.629,423.5,466,423.5,466s-15.386-64.27,9.961-97.749c0,0-.538,0-1.505-.1C417.733,391.786,383.7,374.562,383.7,374.562Z",
    transform: "translate(-51.861 -139.338)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.93,368.219s-46.167-3.617-64.27,9.052-40.12,51.908-40.12,51.908L384.61,444s10.83,1.157,9.93,2.975,14.486,10.86,21.72,8.142,25.346,11.73,27.155,13.577,42.54-2.717,42.54-2.717S470.584,401.708,495.93,368.219Z",
    transform: "translate(-115.219 -139.328)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.2,614.785c20.82,24.437,127.63,19.012,127.63,19.012l39.833,10.85L454.9,677.236c26.4-34.212,25.81-115.744,24.373-148.724-.391-8.856-.831-14.213-.831-14.213s-38.014-23.538-55.218,0c-3.069,4.193-16.84,7.409-19.02,14.213-9.98,31.368,0,85.354,0,85.354l-45.258-4.526L293.193,593.7a59.408,59.408,0,0,0-13.831-1.613C252.1,592.166,157.33,593.808,175.2,614.785Z",
    transform: "translate(107.755 -142.393)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.735,526.6s8.142,1.808,24.437-1.808,22.629,3.617,31.68,7.243,32.589,5.435,41.641,1.808,18.1-10.86,37.144-2.717,31.68-8.152,50.683-6.373S349,517.51,349,517.51l-20.2-46.646-6.06-14.007L171.3,446.5h-.723Z",
    transform: "translate(278.892 -141.102)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,374.624s49.783-9.961,73.311,2.717,41.631,40.732,41.631,40.732,14.263,37.864,12.3,48.874-33.106,0-33.106,0-38.923-9.052-44.358,4.526-30.781,6.334-30.781,6.334-52.5-14.486-62.461,1.808Z",
    transform: "translate(280.779 -139.398)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.651,442.555c4.477,11.788,17.751,17.663,30.165,19.9a99.6,99.6,0,0,0,36.978-.332,74.348,74.348,0,0,1-19.99-41.054c-3.333-24,5.239-48.493,1.711-72.451-3.626-24.6-19.657-46.186-22.433-70.9,5.513,3.558,11.857-3.206,14.75-9.1a240.156,240.156,0,0,0,13.4-33.567c4.487-14.291,8.5-30.3,20.84-38.787,2.18-1.505,5.122-2.717,7.38-1.32,1.652.977,36.5,29.439,42.29,44.761,5.777,15.239,8.445,34.21,14.145,49.508,13.059,34.994-21.407,78.14-23.46,115.441-.919,16.471.45,32.98,1.818,49.412.225,2.629.645,5.6,2.825,7.077a8.319,8.319,0,0,0,4.672.977,63.838,63.838,0,0,0,21.514-3.6c2.786-.977,5.581-2.17,8.533-2.219,4.36-.068,8.328,2.326,12.512,3.578,14.105,4.242,28.787-4.839,39.031-15.415s18.924-23.391,32.1-29.931c4.311-2.15,9.951-5.259,8.8-9.941a9.461,9.461,0,0,0-2.807-4.1c-5.337-5.366-10.948-10.557-15.317-16.735-6.588-9.335-10.019-20.469-13.362-31.4-4.829-15.816-9.706-32.022-8.8-48.532.43-8.182,2.287-16.226,3-24.437,1.408-16.265-1.779-32.531-4.946-48.542-2.15-10.909-4.487-22.218-11.2-31.084-4.565-6.021-10.84-10.488-15.962-16.05-7.644-8.3-12.434-18.758-18.631-28.191s-14.6-18.367-25.63-20.762c-6.676-1.456-13.626-.342-20.371.782-5.386.909-10.9,1.847-15.992,3.91-4.017,1.6-7.712,5.562-11.828,6.315-8.191,1.535-17.194-1.681-25.962.391-17.057,4.017-32.619,15.454-40.184,31.436a71.942,71.942,0,0,0-3.734,9.775c-1.447,4.692-2.551,9.491-3.646,14.281-.235.977-.459,2.033-.674,3.04h0c-6.7,31.827-2.375,55,.547,88.111s3.636,77.466-5.572,109.478C210.319,415.654,202.725,429.584,207.651,442.555Z",
    transform: "translate(99.875 -134.066)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.359,
    cy: 1.359,
    rx: 1.359,
    ry: 1.359,
    transform: "translate(299.707 522.625)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.475 300.621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.876,641.858,371.449,619.19l-2.717,43.449,100.847,8.172a65.863,65.863,0,0,0,20.732-1.583L594.061,644.7a1.447,1.447,0,0,0-.186-2.844Z",
    transform: "translate(-168.585 -445.725)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.788,391.88,514.9,389.07a24,24,0,0,0-15.1,6.683,15.757,15.757,0,0,0-4.711,13.434L520.938,584c1.276,8.667,10,15.352,20.732,15.877l232.925,11.71a25.076,25.076,0,0,0,17.707-5.814c4.524-4,6.587-9.45,5.616-14.826L766.99,407.231C765.268,397.68,754.609,390.921,742.788,391.88Z",
    transform: "translate(-494.95 -389.07)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.86,
    cy: 10.86,
    rx: 10.86,
    ry: 10.86,
    transform: "translate(129.868 73.439)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78 -35)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 40,
    rx: 16,
    transform: "translate(483 293)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.109,2.539v-20H9.19a7.361,7.361,0,0,1,3.453.718,4.787,4.787,0,0,1,2.025,1.919,5.416,5.416,0,0,1,.664,2.664,4.424,4.424,0,0,1-.456,2.128,3.692,3.692,0,0,1-1.2,1.336,5.574,5.574,0,0,1-1.616.738v.188a3.9,3.9,0,0,1,1.871.644,4.708,4.708,0,0,1,1.556,1.678,5.265,5.265,0,0,1,.624,2.658,5.365,5.365,0,0,1-.691,2.711,4.759,4.759,0,0,1-2.166,1.913,8.94,8.94,0,0,1-3.835.7ZM4.657.284H9.351a4.888,4.888,0,0,0,3.319-.9,2.866,2.866,0,0,0,.986-2.2,3.522,3.522,0,0,0-.51-1.852A3.733,3.733,0,0,0,11.7-6.025a4.557,4.557,0,0,0-2.219-.51H4.657Zm0-8.966h4.4a4.077,4.077,0,0,0,2.722-.94,3.089,3.089,0,0,0,1.113-2.483,2.984,2.984,0,0,0-.905-2.2,3.91,3.91,0,0,0-2.85-.9H4.657Z",
    transform: "translate(504.891 320.461)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-147 -78.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.137,17.31a1.12,1.12,0,0,1-.8-.341,1.183,1.183,0,0,1,0-1.646l6.821-6.982a1.118,1.118,0,0,1,1.608,0,1.183,1.183,0,0,1,0,1.646L9.941,16.969A1.12,1.12,0,0,1,9.137,17.31Z",
    transform: "translate(703.684 378.752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.095,16.9a1.123,1.123,0,0,1-.859-.4,1.183,1.183,0,0,1,.112-1.642l.575-.512c1.882-1.956,2.759-6.032,1.111-7.72s-5.628-.791-7.54,1.135l-.5.59a1.119,1.119,0,0,1-1.6.12,1.183,1.183,0,0,1-.117-1.641L9.8,6.2q.027-.032.056-.062A9.741,9.741,0,0,1,15.068,3.53a6.132,6.132,0,0,1,5.575,1.448,6.488,6.488,0,0,1,1.414,5.707,10.153,10.153,0,0,1-2.552,5.331q-.028.029-.058.056l-.607.54A1.117,1.117,0,0,1,18.095,16.9Z",
    transform: "translate(703.821 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.162,22.49a5.67,5.67,0,0,1-4.146-1.568A7.078,7.078,0,0,1,3,15.981c0-2.06,2.053-4.993,3.152-6.105L6.2,9.83l.6-.539a1.119,1.119,0,0,1,1.6.1,1.183,1.183,0,0,1-.1,1.643l-.571.516c-1.079,1.1-2.456,3.435-2.456,4.429a4.708,4.708,0,0,0,1.341,3.287c1.655,1.675,5.64.8,7.581-1.105l.4-.547a1.12,1.12,0,0,1,1.591-.24A1.182,1.182,0,0,1,16.417,19l-.451.621a1.157,1.157,0,0,1-.113.133,9.854,9.854,0,0,1-5.236,2.607A8.875,8.875,0,0,1,9.162,22.49Z",
    transform: "translate(703 378.916)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 40,
    transform: "translate(591 293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.773,1.965,3.22-12.564H5.6L3.154,1.965ZM4.821-14.942A1.39,1.39,0,0,1,3.736-15.4a1.245,1.245,0,0,1-.3-1.092,1.723,1.723,0,0,1,.675-1.1,1.965,1.965,0,0,1,1.243-.448,1.415,1.415,0,0,1,1.1.448,1.247,1.247,0,0,1,.3,1.1A1.741,1.741,0,0,1,6.077-15.4,1.965,1.965,0,0,1,4.821-14.942Z",
    transform: "translate(536.227 321.035)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0A2,2,0,1,1,0,2,2,2,0,0,1,2,0Z",
    transform: "translate(608 355)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,2H18a4,4,0,0,1,4,4V18a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V6A4,4,0,0,1,6,2ZM18,20a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6V18a2,2,0,0,0,2,2Z",
    transform: "translate(596 349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,17a1,1,0,0,1-.707-.293L10.3,11.714a1.023,1.023,0,0,0-1.6,0L3.707,16.707a1,1,0,1,1-1.414-1.414l5-5,.014-.013a3.014,3.014,0,0,1,4.387,0l.014.013,5,5A1,1,0,0,1,16,17Z",
    transform: "translate(596 349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,17a1,1,0,0,1-.707-.293L17.3,13.714a1.023,1.023,0,0,0-1.6,0l-.993.993a1,1,0,0,1-1.414-1.414l1-1,.014-.013a3.014,3.014,0,0,1,4.387,0l.014.013,3,3A1,1,0,0,1,21,17Z",
    transform: "translate(596 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75,25A2.805,2.805,0,0,1,4,22.143V13.572C4,9.1,6.269,6.153,10.541,5.043a1.372,1.372,0,0,1,1.668,1.039,1.433,1.433,0,0,1-1,1.733c-3.062.8-4.459,2.61-4.459,5.757V15h4.125a2.8,2.8,0,0,1,2.743,2.643l.007.214v4.286A2.805,2.805,0,0,1,10.875,25Z",
    transform: "translate(749.375 305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75,25A2.805,2.805,0,0,1,13,22.143V13.572c0-4.471,2.269-7.418,6.541-8.528a1.372,1.372,0,0,1,1.668,1.039,1.433,1.433,0,0,1-1,1.733c-3.062.8-4.459,2.61-4.459,5.757V15h4.125a2.8,2.8,0,0,1,2.743,2.643l.007.214v4.286A2.805,2.805,0,0,1,19.875,25Z",
    transform: "translate(728 305)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.05 -85.367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.039,463.43a1.858,1.858,0,0,0-1.136,2.365l25.937,74.754a1.858,1.858,0,0,0,2.365,1.136l150.916-52.95a1.858,1.858,0,0,0,1.136-2.365L389.32,411.615a1.858,1.858,0,0,0-2.365-1.136Z",
    transform: "translate(204.124 -4.027)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.711,540.473a14.379,14.379,0,0,1-13.547-9.571l-14.244-40.3a14.354,14.354,0,0,1,8.75-18.317l96.793-32.227c29.729-10.471,41.8,10.368,52.341,40.074a14.354,14.354,0,0,1-8.75,18.317l-.111-.313.111.313-116.574,41.2a14.3,14.3,0,0,1-4.77.821Z",
    transform: "translate(198.651 -13.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.475,469.535l-68.3,23.962c-.962.338-2.155-.565-2.664-2.015s-.141-2.9.821-3.238l68.3-23.963c.962-.338,2.155.565,2.664,2.015S411.438,469.2,410.475,469.535Z",
    transform: "translate(169.036 -22.106)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.428,492.2l-68.3,23.963c-.962.338-2.155-.565-2.664-2.015s-.141-2.9.821-3.238l68.3-23.963c.962-.338,2.155.565,2.664,2.015S419.39,491.867,418.428,492.2Z",
    transform: "translate(166.365 -29.719)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.334,
    cy: 4.334,
    rx: 4.334,
    ry: 4.334,
    transform: "translate(477.96 479.998)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.445,544.488c1.113-2.582,2.428-6.522,5.474-5.088,1.505.653,4.2,2.635,5.295.329l8.57-17.939a2.791,2.791,0,0,1,3.787-1.263l15.235,7.971a21.97,21.97,0,0,1-.365,3.685l-37.1,13.114Z",
    transform: "translate(181.218 -42.916)",
    fill: "#f59e0b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(540.32 386.688) rotate(11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.781,137.939H12.336A12.35,12.35,0,0,1,0,125.6V12.336A12.35,12.35,0,0,1,12.336,0h89.726l19.055,15.188V125.6A12.35,12.35,0,0,1,108.781,137.939Z",
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.785,0A8.8,8.8,0,0,0,0,8.785V122.051a8.8,8.8,0,0,0,8.785,8.785h96.445a8.8,8.8,0,0,0,8.785-8.785V13.347L97.269,0Z",
    transform: "translate(3.551 3.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.964,4.109H2.054A2.054,2.054,0,0,1,2.054,0h43.91a2.054,2.054,0,0,1,0,4.109Z",
    transform: "translate(44.058 32.378)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.438,4.109H2.054A2.054,2.054,0,0,1,2.054,0H54.438a2.054,2.054,0,1,1,0,4.109Z",
    transform: "translate(44.058 39.311)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.963,0H2.054a2.054,2.054,0,1,0,0,4.108H45.963a2.054,2.054,0,0,0,0-4.108Z",
    transform: "translate(44.06 63.447)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.437,0H2.054a2.054,2.054,0,1,0,0,4.108H54.437a2.054,2.054,0,1,0,0-4.108Z",
    transform: "translate(44.06 70.382)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.964,4.108H2.054A2.054,2.054,0,0,1,2.054,0h43.91a2.054,2.054,0,0,1,0,4.109Z",
    transform: "translate(44.058 94.519)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.438,4.109H2.054A2.054,2.054,0,0,1,2.054,0H54.438a2.054,2.054,0,1,1,0,4.109Z",
    transform: "translate(44.058 101.452)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.261,
    cy: 7.261,
    r: 7.261,
    transform: "translate(20.566 30.638)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.464,5.522a.753.753,0,0,1-.453-.151L2,5.366.3,4.06a.758.758,0,0,1,.923-1.2L2.325,3.7,4.937.3A.758.758,0,0,1,6,.156H6L5.983.179,6,.157A.759.759,0,0,1,6.14,1.22L3.068,5.226a.758.758,0,0,1-.6.3Z",
    transform: "translate(24.643 35.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.521,7.262a7.261,7.261,0,0,1-7.26,7.263,1.559,1.559,0,0,1-.187-.007,7.26,7.26,0,1,1,7.446-7.256Z",
    transform: "translate(21.313 61.706)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.261,
    cy: 7.261,
    r: 7.261,
    transform: "translate(20.566 92.779)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.035,15.39H4.108A4.109,4.109,0,0,1,0,11.281V.257a.257.257,0,0,1,.416-.2L19.194,14.932a.257.257,0,0,1-.159.458Z",
    transform: "translate(101.711 0.287)",
    fill: "#e6e6e6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.43d715a6f9851992d625150f37bf09c4.svg";
export { ForwardRef as ReactComponent };